import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { PageHeaderText } from 'iovisit-museum-theme/components/Views';

import {
  InfoBox,
  Booking,
  PageMetadata,
  ViewBlocks,
  RichText,
  RelatedItems,
  hasBooking,
} from 'iovisit-theme/components/Views';

import { When } from 'iovisit-theme/components';

const messages = defineMessages({
  museumAddress: {
    id: 'museum_address',
    defaultMessage: 'Indirizzo',
  },
  museumTimetable: { id: 'museum_timetable', defaultMessage: 'Orari' },
  museumTicket: {
    id: 'museum_ticket',
    defaultMessage: 'Biglietti',
  },
  downloadProgram: {
    id: 'museum_download_program',
    defaultMessage: 'Scarica programma',
  },
  downloadPoster: {
    id: 'museum_download_poster',
    defaultMessage: 'Scarica la locandina',
  },
  related_museum: {
    id: 'related_museum',
    defaultMessage: 'Scopri gli altri musei',
  },
  related_items: {
    id: 'museum_related_items',
    defaultMessage: 'Correlati in evidenza',
  },
});

const MuseumView = ({ content, location }) => {
  const intl = useIntl();

  const timetable = RichText({
    content: content.timetable,
    title: intl.formatMessage(messages.museumTimetable),
    titleTag: 'h3',
  });

  const prices = RichText({
    content: content.prices,
    title: intl.formatMessage(messages.museumTicket),
    titleTag: 'h3',
  });

  const infoBoxHasData =
    content.street ||
    content.zip_code ||
    content.city ||
    content.country ||
    content.start ||
    content.end;

  return content ? (
    <div id="page-museum" className="ui container" key={content['@id']}>
      <PageHeaderText content={content} showDownloadApp={true} />

      {(infoBoxHasData || timetable || prices || hasBooking(content)) && (
        <InfoBox>
          {(content.street ||
            content.zip_code ||
            content.city ||
            content.country) && (
            <>
              <h3>{intl.formatMessage(messages.museumAddress)}</h3>
              <p>
                {content.street && content.street}
                {content.street && content.zip_code && ', '}
                {content.zip_code && content.zip_code + ' '}
                {content.city && content.city + ' '}
              </p>
            </>
          )}
          {(content.start || content.end) && (
            <When
              start={content.start}
              end={content.end}
              whole_day={content.whole_day}
              open_end={content.open_end}
              show_times={true}
              recurrence={content.recurrence}
            />
          )}
          {timetable && timetable}

          {prices && prices}

          <Booking content={content} />
        </InfoBox>
      )}

      <ViewBlocks content={content} location={location} />

      {/* Musei correlati */}
      {content.related_museum?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_museum)}
          items={content.related_museum}
          background={true}
        />
      )}

      {/* Items correlati */}
      {content.relatedItems?.length > 0 && (
        <RelatedItems
          title={intl.formatMessage(messages.related_items)}
          items={content.relatedItems}
          background={(content.related_museum || []).length === 0}
        />
      )}

      <PageMetadata content={content} />
    </div>
  ) : null;
};

export default MuseumView;
